const FENCE = /^\s{0,3}(`{3,}|~{3,})/;
/** Closes only with the same character, at least as long, and nothing after it. */
const CLOSING_FENCE = /^\s{0,3}(`{3,}|~{3,})\s*$/;
/** List item, heading, blockquote or table row. Fences are tracked separately. */
const BLOCK_START = /^\s*(?:[-*+](?:\s|$)|\d+[.)](?:\s|$)|#{1,6}(?:\s|$)|>|\|)/;
/** Thematic break or setext underline: it belongs to the line above. */
const RULE_LINE = /^\s{0,3}(?:(?:-[ \t]*){3,}|(?:\*[ \t]*){3,}|(?:_[ \t]*){3,}|=+[ \t]*)$/;
/** A backslash or two trailing spaces already end the line with a hard break. */
const HARD_BREAK = /(?:\\| {2,})$/;

function isPlainLine(line: string): boolean {
  return !BLOCK_START.test(line) && !RULE_LINE.test(line);
}

/**
 * Notes typed in a textarea used one newline per line, which markdown reads as
 * a soft break and BlockNote would merge into one paragraph. Give each such
 * line its own paragraph before parsing (TD-092). Block constructs, fenced
 * code and hard breaks are left alone.
 */
export function splitSoftBreaks(markdown: string): string {
  const out: string[] = [];
  let fence: string | null = null;
  let previous: string | null = null;

  for (const line of markdown.split("\n")) {
    if (fence !== null) {
      out.push(line);
      const closing = line.match(CLOSING_FENCE);
      if (closing && closing[1][0] === fence[0] && closing[1].length >= fence.length) fence = null;
      previous = null;
      continue;
    }

    const opening = line.match(FENCE);
    if (opening) {
      fence = opening[1];
      out.push(line);
      previous = null;
      continue;
    }

    const blank = line.trim() === "";
    if (!blank && previous !== null && !HARD_BREAK.test(previous) && isPlainLine(previous) && isPlainLine(line)) {
      out.push("");
    }
    out.push(line);
    previous = blank ? null : line;
  }

  return out.join("\n");
}
